module.exports = __webpack_public_path__ + "media/colorsseumGameplay.44347bd0.mp4";